
  import {prepareImageUrl} from '@/helper/ImageHelper';

  export default {
    components: {
      RichText: () => import('@/components/elements/RichText'),
    },
    props: {
      wiki: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        imageUrl: '',
      };
    },
    created() {
      if (this.wiki.cover[0]) {
        this.imageUrl = prepareImageUrl(this.wiki.cover[0].url);
      }
    },
  };
